<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :loading="modalLoading" :data="queryInstanceByGroupIdList" :height="500">
    </Table>
  </div>
</template>
<script>
    var tableInstances = {}
    export default {
        name: 'TableInstances',
        data() {
            return {
                Name: '',
                modalLoading: false,
                columns: [
                    {
                        title: this.$t('rule_engine.name'),
                        key: 'name'
                    },
                    {
                        title: this.$t('rule_engine.instanceId'),
                        key: 'instanceId'
                    },
                    {
                        title: this.$t('rule_engine.region'),
                        key: 'region'
                    },
                    {
                        title: this.$t('rule_engine.privateIP'),
                        key: 'privateIp'
                    }
                ],
                queryInstanceByGroupIdList: []
            }
        },
        beforeCreate: function () {
            tableInstances = this
        },
        mounted: function () {
            tableInstances.queryInstancesByGroupId()
        },
        methods: {
          queryInstancesByGroupId: function () {
            this.modalLoading = true
            tableInstances.$api.alertRule.selectInstantiationByAlertRule('id', this.$route.query.id)
              .then(res => {
                this.queryInstanceByGroupIdList = res.data[0].instanceList;
                this.modalLoading = false
              }) .catch(res => {
              // 如果列表里没数据 返回
              this.queryInstanceByGroupIdList = undefined
            })

          }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/rule_engine/TableInstances.vue